var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { selectBalancingResource } from "../../../balancingSelectors/selectBalancingResources";
import { IdResource } from "../../../constants/IdResource";
import { IdStyles } from "../../../less/IdStyles";
import { selectInventoryResourceInfo } from "../../../selectors/selectInventoryInfo";
import { HOCHudComponent } from "../../context-menu/HOCHudComponent";
import { actionGameTrackingShopOpenSource } from "../../game-tracking/shop/actionGameTrackingShop";
import { IdShopOpenSource } from "../../game-tracking/shop/IdShopOpenSource";
import { ResourceWithButton } from "../../generic/resource-with-button/ResourceWithButton";
import { actionInventoryInfoRequestAddResource } from "../../info/inventory/actionInventoryInfo";
import { actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
var _HudCurrency = function (_a) {
    var inventoryInfo = _a.inventoryInfo, gold = _a.gold, money = _a.money, onGoldResourceClick = _a.onGoldResourceClick, onMoneyResourceClick = _a.onMoneyResourceClick, onShopOpen = _a.onShopOpen;
    return (React.createElement("div", { className: "hud-player-base-currency" },
        React.createElement(ResourceWithButton, { resource: money, styleId: "hud-icon-with-text--icon " + IdStyles.IconLarge, backgroundSize: "medium", backgroundClassName: IdStyles.HudStat, className: "hud-icon-with-text", onButtonClick: onMoneyResourceClick, centerText: false }),
        React.createElement(ResourceWithButton, { resource: gold, styleId: "hud-icon-with-text--icon " + IdStyles.IconLarge, backgroundSize: "medium", backgroundClassName: IdStyles.HudStat, className: "hud-icon-with-text", onButtonClick: function () {
                onGoldResourceClick();
                onShopOpen();
            }, centerText: false })));
};
var mapState = function (state) {
    var goldProto = selectInventoryResourceInfo(state, IdResource.Gold);
    var moneyProto = selectInventoryResourceInfo(state, IdResource.Money);
    var goldBalancing = selectBalancingResource(IdResource.Gold);
    var moneyBalancing = selectBalancingResource(IdResource.Money);
    return {
        gold: __assign({}, goldProto, goldBalancing, { amount: goldProto.amount }),
        inventoryInfo: state.inventoryInfo,
        money: __assign({}, moneyProto, moneyBalancing, { amount: moneyProto.amount }),
    };
};
var mapDispatch = function (dispatch) { return ({
    onGoldResourceClick: function () { return dispatch(actionModalOpen(IdModal.Shop)); },
    onMoneyResourceClick: function () { return dispatch(actionInventoryInfoRequestAddResource(IdResource.Money)); },
    onShopOpen: function () { return dispatch(actionGameTrackingShopOpenSource(IdShopOpenSource.ADD_GOLD_BUTTON)); },
}); };
export var HudCurrency = connect(mapState, mapDispatch)(HOCHudComponent(_HudCurrency));



//////////////////
// WEBPACK FOOTER
// ./src/features/inventory/currency/HudCurrency.tsx
// module id = 2312
// module chunks = 3